import React, { useState, useEffect, useContext } from 'react';
import './Myorders.css';
import { useNavigate } from 'react-router-dom';
import { useNav } from '../../Context/NavContext';
import AddReview from '../AddReview/AddReview';
import { UrlContext } from '../../Context/UrlContext';

function Myorders() {


          const { apiBaseUrl } = useContext(UrlContext);

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const navigate = useNavigate();
  const { setActiveItem } = useNav();
  
  // Get user data from localStorage
  const getUserData = () => {
    try {
      // Try to get user data from different possible storage keys
      const userData = localStorage.getItem('user');
      const userString = localStorage.getItem('userData');
      
      if (userData) {
        return JSON.parse(userData);
      } else if (userString) {
        return JSON.parse(userString);
      }
      return null;
    } catch (err) {
      console.error('Error parsing user data:', err);
      return null;
    }
  };

  const user = getUserData();
  const userId = user?.id || user?.user_id;

  // Format price to 2 decimal places
  const formatPrice = (price) => {
    if (typeof price === 'string') {
      price = parseFloat(price);
    }
    return typeof price === 'number' && !isNaN(price) ? price.toFixed(2) : '0.00';
  };

  useEffect(() => {
    if (!user || !userId) {
      console.log('User data:', user);
      console.log('User ID:', userId);
      setError('User session not found. Please try logging in again.');
      setLoading(false);
      return;
    }
    fetchOrders();
  }, [userId]);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      console.log('Fetching orders for user ID:', userId);
      
      const response = await fetch(`${apiBaseUrl}/orders?userId=${userId}`, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch orders');
      }

      const data = await response.json();
      console.log('Full orders data:', data);
      
      const userOrders = data.filter(order => order.user_id === String(userId));
      console.log('Filtered user orders:', userOrders);
      
      // Log first order's cart items for structure check
      if (userOrders.length > 0 && userOrders[0].cart_items) {
        console.log('First order cart items with product IDs:', userOrders[0].cart_items.map(item => ({
          cart_order_id: item.cart_order_id,
          product_id: item.product_id,
          product_name: item.product_name
        })));
      }
      
      const sortedOrders = userOrders.sort((a, b) => 
        new Date(b.created_at) - new Date(a.created_at)
      );
      
      setOrders(sortedOrders);
      setError(null);
    } catch (err) {
      console.error('Error fetching orders:', err);
      setError(err.message || 'Failed to load your orders. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleReviewClick = (cartItem) => {
    console.log('Cart item in handleReviewClick:', cartItem);
    if (!cartItem.cart_order_id) {
      console.error('No cart order ID found');
      return;
    }

    if (!cartItem.product_id) {
      console.error('No product ID found in cart item:', cartItem);
      return;
    }

    // Set the product ID directly from the cart item
    setSelectedProductId(cartItem.product_id);
    setIsReviewModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsReviewModalOpen(false);
    setSelectedProductId(null);
  };

  const handleReviewSubmitted = () => {
    setIsReviewModalOpen(false);
    setSelectedProductId(null);
    fetchOrders();
  };

  const getStatusColor = (status) => {
    const statusColors = {
      pending: '#f0ad4e',
      processing: '#5bc0de',
      shipped: '#0275d8',
      delivered: '#5cb85c',
      cancelled: '#d9534f'
    };
    return statusColors[status] || '#666';
  };

  const formatDate = (dateString) => {
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  if (!user || !userId) {
    return (
      <div className="myorders-error">
        <p>User session not found. Please try logging in again.</p>
        <button 
          onClick={() => window.location.href = '/login'} 
          className="login-button"
        >
          Go to Login
        </button>
      </div>
    );
  }

  if (loading) return <div className="myorders-loading">Loading your orders...</div>;
  if (error) {
    return (
      <div className="myorders-error">
        <p>{error}</p>
        <button 
          onClick={fetchOrders} 
          className="retry-button"
        >
          Retry Loading Orders
        </button>
      </div>
    );
  }
  if (orders.length === 0) {
    return (
      <div className="myorders-empty">
        <p>You haven't placed any orders yet.</p>
        <button 
          onClick={() => {
            setActiveItem('COLLECTION');
            navigate('/');
          }} 
          className="shop-button"
        >
          Start Shopping
        </button>
      </div>
    );
  }

  return (
    <div className='myorders_container'>
      <h2>My Orders</h2>
      
      <div className="myorders_list">
        {orders.map((order) => (
          <div key={order.order_id} className="myorder_card">
            <div className="myorder_header">
              <div className="myorder_info">
                <h3>Order #{order.order_id}</h3>
                <p className="order-date">
                  Ordered on: {formatDate(order.created_at)}
                </p>
                 <div className="p_messege">
                {order.status === 'pending' ? (<p>Admin will contact you soon Mannually</p>) : ''}
              </div>
              </div>
              <div className="order_status" style={{ color: getStatusColor(order.status) }}>
                <span className="status-dot" style={{ backgroundColor: getStatusColor(order.status) }}></span>
                {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
              </div>
            </div>

            <div className="order_progress">
              <div className="progress-track">
                {['pending', 'processing', 'shipped', 'delivered'].map((status, index) => (
                  <div 
                    key={status}
                    className={`progress-step ${
                      ['pending', 'processing', 'shipped', 'delivered'].indexOf(order.status) >= index ? 'active' : ''
                    } ${order.status === 'cancelled' ? 'cancelled' : ''}`}
                  >
                    <div className="step-icon"></div>
                    <div className="step-label">{status.charAt(0).toUpperCase() + status.slice(1)}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="order_items">
              <div className="items_grid">
                {order.cart_items && order.cart_items.map((item) => (
                  <div key={item.cart_order_id} className="order_item">
                    <div className="item_image">
                      <img 
                        src={`data:image/jpeg;base64,${item.product_image}`} 
                        alt={item.product_name} 
                      />
                    </div>
                    <div className="item_details">
                      <h4>{item.product_name}</h4>
                      <p className="item_size">Size: {item.size}</p>
                      <p className="item_quantity">Quantity: {item.quantity}</p>
                      <p className="item_price">Rs. {formatPrice(item.unit_price)} per item</p>
                      <p className="item_total">Total: Rs. {formatPrice(item.item_total)}</p>
                      <p className="debug_info">Product ID: {item.product_id}</p>
                      {order.status === 'delivered' && (
                        <button 
                          className="review-button"
                          onClick={() => handleReviewClick(item)}
                        >
                          Write a Review
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="order_summary">
              <div className="summary_row">
                <span>Subtotal:</span>
                <span>Rs. {formatPrice(order.sub_total)}</span>
              </div>
              <div className="summary_row">
                <span>Shipping Fee:</span>
                <span>Rs. {formatPrice(order.shipping_fee)}</span>
              </div>
              <div className="summary_row total">
                <span>Total:</span>
                <span>Rs. {formatPrice(order.total)}</span>
              </div>
            </div>

            <div className="shipping_details">
              <h4>Shipping Details</h4>
              <p>{order.first_name} {order.last_name}</p>
              <p>{order.address}</p>
              <p>{order.postal_code}, {order.country}</p>
              <p>Phone: {order.phone_number}</p>
              <p>Email: {order.email}</p>
            </div>
          </div>
        ))}
      </div>

      <AddReview 
        productId={selectedProductId}
        isOpen={isReviewModalOpen}
        onClose={handleCloseModal}
        onReviewSubmitted={handleReviewSubmitted}
      />
    </div>
  );
}

export default Myorders;
